const readURL = (input) => {
  const imagePreview = document.querySelector('#img_prev');
  imagePreview.style.display = "";
  if (document.querySelector('#avatar-remove')) {
    const avatarImage = document.querySelector('#avatar-remove');
    avatarImage.style.display ="none";
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {
      $('#img_prev')
        .attr('src', e.target.result)
        .width(45)
        .height(45);
    };

    reader.readAsDataURL(input.files[0]);
  }
}

export { readURL };
